import { sortDataType, sortDirection } from './constants';

const defaultSortValue = (dataType) => {
    switch (dataType) {
    case sortDataType.date:
        return new Date(0);
    default:
        return '';
    }
};

export const toggleSortDirection = current => (!current || current === sortDirection.desc ? sortDirection.asc : sortDirection.desc);

export const getValueByDotNotation = (obj, propName, dataType) => {
    if (!obj || !propName) { return defaultSortValue(dataType); }
    return propName.split('.').reduce((prev, curr) => (prev ? prev[curr] || defaultSortValue(dataType) : defaultSortValue(dataType)), obj);
};

const sortCompNumber = (a, b, sorting) => getValueByDotNotation(sorting.direction === sortDirection.asc ? a : b, sorting.columnName, sorting.dataType) - getValueByDotNotation(sorting.direction === sortDirection.asc ? b : a, sorting.columnName, sorting.dataType);
const sortCompString = (a, b, sorting) => getValueByDotNotation(sorting.direction === sortDirection.asc ? a : b, sorting.columnName, sorting.dataType).localeCompare(getValueByDotNotation(sorting.direction === sortDirection.asc ? b : a, sorting.columnName, sorting.dataType));
const sortCompDate = (a, b, sorting) => new Date(getValueByDotNotation(sorting.direction === sortDirection.asc ? b : a, sorting.columnName, sorting.dataType)) - new Date(getValueByDotNotation(sorting.direction === sortDirection.asc ? a : b, sorting.columnName, sorting.dataType));
export const sortByColumn = (array, sorting) => {
    if (!array || !sorting) {
        return array || [];
    }

    switch (sorting.dataType) {
    case sortDataType.date:
        return array.sort((a, b) => sortCompDate(a, b, sorting));
    case sortDataType.number:
        return array.sort((a, b) => sortCompNumber(a, b, sorting));
    default:
        return array.sort((a, b) => sortCompString(a, b, sorting));
    }
};
